import PrivateSideMenuBar from './PrivateSideMenuBar'

export default PrivateSideMenuBar
